import types from "types";

export const setFilter = (filter = null) => dispatch => {
  dispatch({
    type: types.SET_FILTER,
    payload: filter,
  })
}

export const setTimeFrame = (timeFrame = 'week') => dispatch => {
  dispatch({
    type: types.SET_TIME_FRAME,
    payload: timeFrame,
  })
}

export const clearFilters = () => dispatch => {
  dispatch({
    type: types.CLEAR_FILTER
  })
}